export const QUERY_PARAMS_KEYS = {
  figmaCallbackEmail: "figmaCallbackEmail",
  figmaCallbackFileURL: "figmaCallbackFileURL",
};
